import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c(VContainer,[_c('id-alerts',{attrs:{"alerts":_vm.alert}}),_c('return-display',{attrs:{"article":_vm.trustevResult,"idvAuth":_vm.trustAuth}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }